import { Flex, HStack, Icon, Text } from '@chakra-ui/react';
import { NotificationType } from '@client/graphql/__generated__/types';
import { Circle, Mail, MessageSquareText } from 'lucide-react';

interface NotificationTypeToggleProps {
  value: NotificationType;
  onChange: (value: NotificationType) => void;
}

export const NotificationTypeToggle = ({
  value,
  onChange,
}: NotificationTypeToggleProps) => {
  const options = [
    { type: NotificationType.TEXT, label: 'Text', icon: MessageSquareText },
    { type: NotificationType.EMAIL, label: 'Email', icon: Mail },
  ];

  return (
    <Flex
      alignItems="center"
      borderBottom="1px solid"
      borderColor="whiteAlpha.100"
      justifyContent="space-between"
      py={5}
    >
      <Text color="whiteAlpha.700" id="notification-type-label">
        Notification type
      </Text>
      <HStack
        aria-labelledby="notification-type-label"
        role="group"
        spacing={2}
      >
        {options.map((option) => {
          const isSelected = value === option.type;

          return (
            <Flex
              key={option.type}
              alignItems="center"
              aria-pressed={isSelected}
              as="button"
              bg={isSelected ? 'white' : 'whiteAlpha.50'}
              border="1px solid"
              borderColor="whiteAlpha.100"
              borderRadius="sm"
              cursor="pointer"
              gap={4}
              px={3}
              py={2}
              transition="all 0.2s"
              type="button"
              onClick={() => onChange(option.type)}
            >
              <Flex alignItems="center" gap={1}>
                <Icon
                  as={option.icon}
                  boxSize={4}
                  color={isSelected ? 'indigo.900' : 'white'}
                />
                <Text
                  color={isSelected ? 'indigo.900' : 'white'}
                  fontSize="sm"
                  fontWeight="medium"
                >
                  {option.label}
                </Text>
              </Flex>
              <Icon
                as={Circle}
                boxSize={4}
                color={isSelected ? 'indigo.900' : 'whiteAlpha.400'}
                fill={isSelected ? 'indigo.900' : 'transparent'}
              />
            </Flex>
          );
        })}
      </HStack>
    </Flex>
  );
};
